import { Textarea } from "@repo/core/components/core/Textarea";
import { Controller } from "react-hook-form";

import { TextAreaControlledProps } from "./types";

export const TextAreaControlled = ({
  name,
  control,
  defaultValue,
  onChange,
  ...props
}: TextAreaControlledProps) => {
  return (
    <Controller
      defaultValue={defaultValue}
      control={control}
      name={name}
      render={({
        field: { onChange: onChangeField, value, onBlur },
        fieldState: { error }
      }) => {
        return (
          <Textarea
            {...props}
            isInvalid={!!error?.message}
            errorMessage={error?.message || ""}
            onChange={(value) => {
              onChangeField(value);
              onChange?.(value);
            }}
            onBlur={onBlur}
            value={value}
            name={name}
          />
        );
      }}
    />
  );
};
